<template>
  <input
    v-model="proxy"
    class="tw-border-dorian-gray-70 tw-my-2 tw-ml-4 tw-mr-2 tw-h-5 tw-w-5 tw-cursor-pointer tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white"
    type="radio"
  />
</template>

<script setup lang="ts">
/**
 * @deprecated
 *
 * Please use `cl-radio-buttons` instead.
 */
import { toRefs, computed } from "vue";

const props = defineProps<{
  modelValue: string | number | boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string | number | boolean];
}>();

const { modelValue } = toRefs(props);

const proxy = computed({
  get() {
    return modelValue.value;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
